import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'crit_boost',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 0.1;
        const r = getRuntimes(state, source.side)[source.slot];
        r.crit = Math.min(1, r.crit + amount);
    }
});
